var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInputEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9638_3761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.333 11.8866V14.8866H3.33301V2.8866H8.33301V1.8866H3.33301C3.06779 1.8866 2.81344 1.99195 2.6259 2.17949C2.43836 2.36703 2.33301 2.62138 2.33301 2.8866V14.8866C2.33301 15.1518 2.43836 15.4062 2.6259 15.5937C2.81344 15.7812 3.06779 15.8866 3.33301 15.8866H11.333C11.5982 15.8866 11.8526 15.7812 12.0401 15.5937C12.2277 15.4062 12.333 15.1518 12.333 14.8866V11.8866H11.333Z",
    fill: "#1C6947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.103 3.76659L13.453 2.11659C13.3035 1.97001 13.1024 1.88791 12.893 1.88791C12.6836 1.88791 12.4826 1.97001 12.333 2.11659L5.33301 9.11659V11.8866H8.09801L15.098 4.88659C15.2446 4.73705 15.3267 4.536 15.3267 4.32659C15.3267 4.11719 15.2446 3.91614 15.098 3.76659H15.103ZM7.68301 10.8866H6.33301V9.53659L11.053 4.81159L12.408 6.16659L7.68301 10.8866ZM13.113 5.46159L11.758 4.10659L12.893 2.97159L14.248 4.32659L13.113 5.46159Z",
    fill: "#1C6947"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9638_3761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.333008 0.886597)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputEdit);
export default __webpack_public_path__ + "res/media/inputEdit.181780cd040fa0bd3dc0b4bc09e28073.svg";
export { ForwardRef as ReactComponent };